'use strict';

exports.__esModule = true;

var _react = require('react');

var _inherit = require('inherit');

var _inherit2 = _interopRequireDefault(_inherit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _inherit2.default)(_react.Component, {
    __constructor: function __constructor() {
        this.__base.apply(this, arguments);
        this.willInit(this.props);
    },


    addBemClassName: true,

    willInit: function willInit() {},
    tag: function tag() {
        return 'div';
    },
    attrs: function attrs() {
        return null;
    },
    mods: function mods() {
        return null;
    },
    cls: function cls(_ref) {
        var _cls = _ref.cls;

        return _cls;
    },
    mix: function mix(_ref2) {
        var _mix = _ref2.mix;

        return _mix;
    },
    render: function render() {
        var props = this.props,
            res = this.__render(this.addBemClassName, this.tag(props), this.attrs(props), this.block, this.elem, this.mods(props), [props.mix, this.mix(props)], this.cls(props), this.content(props, props.children));


        return this.wrap ? this.wrap(res) : res;
    },
    content: function content(_, children) {
        return children;
    }
});